import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentindaund() {



  const cardData =
  {
    keyword: 'Tempo Traveller On Rent in Daund Junction',
    heading: 'Sanavi Travels: Tempo Traveller On Rent in Daund Junction',
    headingDescription: 'Sanavi Travels offers reliable Tempo Traveller On Rent in Daund Junction, providing safe, comfortable, and spacious transportation for families, groups, corporate travelers, and pilgrimage trips. Our fleet of well-maintained AC and non-AC Tempo Travellers ensures ample seating, air-conditioning, and luggage space for a smooth and hassle-free journey. With professional chauffeurs, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund Junction and nearby areas, making it ideal for local travel, outstation trips, Shirdi visits, corporate travel, and group outings. Choose Sanavi Travels for trusted Tempo Traveller rental services in Daund Junction, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird lovers and nature enthusiasts. Often called the 'Bharatpur of Maharashtra,' it attracts migratory birds like flamingos, pelicans, and storks, especially during winter. Boat safaris and sunrise views make it a must-visit destination."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a serene landscape of vast water spread and open skies. The area is ideal for peaceful outings, photography, and birdwatching, particularly during early mornings and evenings."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is an important local religious site in Daund, attracting devotees throughout the year. The temple is known for its calm spiritual atmosphere and traditional rituals performed during festivals."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the major railway hubs in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. The historic junction plays a vital role in trade, travel, and regional connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and seasonal migratory birds. Nature walks and boat rides allow visitors to experience untouched natural beauty and rural landscapes."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane fields and sugar factories that represent the agricultural backbone of the region. These areas highlight rural life and Maharashtra’s cooperative farming culture."
  },
  {
    "title": "Village Temples and Wadas",
    "description": "Traditional village temples and old wadas around Daund reflect the cultural and architectural heritage of rural Maharashtra. These sites offer insight into local traditions, festivals, and community life."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund offers scenic drives with open fields, canals, and sunset views. It is ideal for short nature breaks and relaxed travel experiences."
  },
  {
    "title": "Local Weekly Markets",
    "description": "Weekly markets in Daund are vibrant centers of local trade, selling fresh produce, grains, livestock, and daily essentials. They provide an authentic experience of rural Maharashtra’s lifestyle."
  },
  {
    "title": "Pilgrimage Routes Nearby",
    "description": "Daund lies on important travel routes connecting Pune, Solapur, Pandharpur, and Bhigwan. Many pilgrims use Daund as a transit point while visiting major religious destinations."
  }
]
,



"services": [
  {
    "name": "Tempo Traveller On Rent in Daund Junction",
    "description": "Tempo Traveller On Rent in Daund Junction offers spacious and comfortable travel solutions for groups, families, and corporate clients. Ideal for city trips, outstation tours, and special events, these well-maintained vehicles come with air-conditioning and ample luggage space, ensuring a safe and enjoyable journey."
  },
  {
    "name": "Tempo Traveller Hire Daund",
    "description": "Tempo Traveller Hire Daund provides flexible rental options for short trips, long-distance travel, and sightseeing tours. Professional drivers, air-conditioned interiors, and punctual service make it a reliable choice for family outings, group travel, and corporate transportation."
  },
  {
    "name": "AC Tempo Traveller Daund",
    "description": "AC Tempo Traveller Daund ensures a cool and comfortable ride for all passengers. Perfect for summer trips, long journeys, and executive travel, the fully air-conditioned interiors and smooth ride quality make every trip relaxing and stress-free."
  },
  {
    "name": "Luxury Tempo Traveller Daund",
    "description": "Luxury Tempo Traveller Daund delivers a premium travel experience with high-end seating, spacious interiors, and modern amenities. Ideal for corporate events, weddings, and VIP group travel, this service emphasizes comfort, style, and professional chauffeur-driven service."
  },
  {
    "name": "Outstation Tempo Traveller Daund",
    "description": "Outstation Tempo Traveller Daund provides dependable long-distance travel solutions for groups traveling to nearby cities and tourist destinations. Experienced chauffeurs, air-conditioned interiors, and ample luggage space ensure a safe, comfortable, and timely journey."
  },
  {
    "name": "Family Tempo Traveller Daund",
    "description": "Family Tempo Traveller Daund is perfect for family outings, vacations, and group trips. Spacious seating, air-conditioning, and professional drivers ensure comfort, convenience, and safety for all family members during city or outstation travel."
  },
  {
    "name": "Corporate Tempo Traveller Daund",
    "description": "Corporate Tempo Traveller Daund offers professional and reliable group transportation for business meetings, corporate events, and employee travel. Timely pickups, air-conditioned interiors, and chauffeur-driven service ensure a smooth and productive journey."
  },
  {
    "name": "Affordable Tempo Traveller Daund",
    "description": "Affordable Tempo Traveller Daund provides budget-friendly group travel without compromising on comfort or safety. Ideal for student groups, families, and small corporate teams, this service ensures a reliable, cost-effective, and comfortable ride."
  },
  {
    "name": "Chauffeur Driven Tempo Traveller",
    "description": "Chauffeur Driven Tempo Traveller offers a stress-free travel experience with skilled drivers handling navigation, traffic, and route planning. Perfect for corporate tours, family trips, and sightseeing excursions, this service prioritizes safety, punctuality, and passenger comfort."
  },
  {
    "name": "Best Tempo Traveller Daund",
    "description": "Best Tempo Traveller Daund focuses on providing top-quality group transportation with well-maintained vehicles and professional chauffeurs. Ideal for weddings, corporate events, family trips, and outstation tours, this service emphasizes comfort, reliability, and customer satisfaction."
  },
  {
    "name": "Railway Pickup Tempo Traveller",
    "description": "Railway Pickup Tempo Traveller offers convenient transfers for passengers arriving at Daund Junction. Skilled drivers ensure timely pickups, safe travel, and a comfortable ride to hotels, residences, or other destinations, making train travel hassle-free."
  },
  {
    "name": "Group Travel Daund",
    "description": "Group Travel Daund provides efficient and comfortable transportation solutions for family gatherings, friend trips, corporate outings, and social events. Air-conditioned tempo travellers, experienced chauffeurs, and ample space make group travel convenient and enjoyable."
  },
  {
    "name": "Tourist Tempo Traveller",
    "description": "Tourist Tempo Traveller is ideal for sightseeing and leisure tours in and around Daund. Fully air-conditioned vehicles with professional chauffeurs provide organized, comfortable, and safe travel for families, friends, and tourist groups exploring local attractions."
  },
  {
    "name": "Online Booking Daund",
    "description": "Online Booking Daund allows customers to reserve Tempo Travellers easily through a digital platform. Users can select vehicle type, pickup location, dates, and trip preferences with instant confirmation, ensuring hassle-free, safe, and reliable travel planning."
  },
  {
    "name": "Daund Travel Tempo",
    "description": "Daund Travel Tempo offers complete travel solutions for city tours, outstation trips, and group travel. Well-maintained, air-conditioned vehicles with professional chauffeurs ensure safe, comfortable, and enjoyable journeys for families, corporate groups, and tourist travelers."
  }
],
"tableData": [
  ["Tempo Traveller On Rent in Daund Junction", "Tempo Traveller Hire Daund"],
  ["AC Tempo Traveller Daund", "Luxury Tempo Traveller Daund"],
  ["Outstation Tempo Traveller Daund", "Family Tempo Traveller Daund"],
  ["Corporate Tempo Traveller Daund", "Affordable Tempo Traveller Daund"],
  ["Chauffeur Driven Tempo Traveller", "Best Tempo Traveller Daund"],
  ["Railway Pickup Tempo Traveller", "Group Travel Daund"],
  ["Tourist Tempo Traveller", "Online Booking Daund"],
  ["Daund Travel Tempo", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Tempo Traveller On Rent in Daund Junction with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable Tempo Traveller rentals in Daund Junction, perfect for group trips, family outings, corporate travel, and airport transfers."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced Tempo Travellers to ensure a smooth and enjoyable journey from Daund Junction."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local and long‑distance routes to provide safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Tempo Traveller rentals in Daund Junction, including fuel, tolls, and driver allowances without hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Tempo Traveller rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from local, one‑way, round‑trip, or customized rental packages based on your travel requirements from Daund Junction."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Tempo Traveller rentals in Daund Junction."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Tempo Traveller on rent in Daund Junction?',
    answer: 'Yes, Sanavi Travels offers reliable Tempo Traveller rentals in Daund Junction for group trips and other travel needs.'
  },
  {
    question: 'How can I book a Tempo Traveller in Daund Junction?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the Tempo Travellers well‑maintained and air‑conditioned?',
    answer: 'Yes, all Tempo Travellers provided by Sanavi Travels are clean, air‑conditioned, and regularly serviced.'
  },
  {
    question: 'Are drivers experienced with local and long‑distance routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with both local and long‑distance travel routes.'
  },
  {
    question: 'Can I rent the Tempo Traveller for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized rental packages to meet your travel requirements.'
  },
  {
    question: 'Are the vehicles sanitized before every trip?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is Tempo Traveller rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support for Tempo Traveller rentals.'
  },
  {
    question: 'What payment options are available for Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Tempo Traveller rental trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rakesh Patil',
    feedback: 'Hired a Tempo Traveller from Daund Junction. Spacious vehicle, comfortable ride, and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Excellent Tempo Traveller rental service. Clean vehicle, professional driver, and smooth travel experience.',
    rating: 5
  }
];
















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Daund Junction - Sanavi Travels",
  "description": "Sanavi Travels provides Tempo Traveller rental in Daund Junction for outstation trips, family tours, corporate travel, group travel, and tourist trips. AC, luxury, and chauffeur-driven options available with online booking and railway pickup services.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "420"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller On Rent in Daund Junction | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Traveller in Daund Junction with Sanavi Travels for outstation, family, corporate, group, and tourist travel. AC, luxury, chauffeur-driven options available with railway pickup and online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentindaund;